import type Owner from '@ember/owner';
import { service } from '@ember/service';

import type { PopupData, Service } from 'webapp-types';
import { PopupEvent } from 'webapp/enums/enums';

import CommonUpgradePlanLinkComponent from 'webapp/components/common/upgrade-plan-link';
import type { Args } from 'webapp/components/popup/inner/modal';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';
import SubmitButtonComponent from 'webapp/components/submit-button';

export default class AccountPopupInactivityComponent extends PopupInnerModalComponent<PopupData.Account.Inactivity> {
	@service('request') declare requestService: Service.Request;

	trackingOrigin = 'refresh_on_hold_popup';

	constructor(owner: Owner, args: Args) {
		super(owner, args);

		this.args.model.on(PopupEvent.CLOSING, this, () => {
			this.resolveResolutionCenterMsg();
		});
	}

	get msgId() {
		return this.popupData.msgId;
	}

	resolveResolutionCenterMsg() {
		if (this.msgId) {
			this.requestService
				.api('POST', `/resolution-center/${this.msgId}`)
				.catch(this.requestService.handleGenericThrownError.bind(this.requestService));
		}
	}
	<template>
		<div class="content">
			<h3>
				Since it’s been over 30 days since your last login, we put data refresh on hold.
			</h3>
			<p>
				We’re refreshing your data in the background now. This can take a few minutes.
			</p>
			<p>
				If you’d like us to continually refresh your data even during periods of inactivity,
				<CommonUpgradePlanLinkComponent
					@text="upgrade to one of our paid plans."
					@trackingOrigin={{this.trackingOrigin}}
				/>
			</p>

			<div class="controls2">
				<div class="controls2__right">
					<SubmitButtonComponent
						@text="Continue"
						@noDelay={{true}}
						@onTrigger={{this.close}}
					/>
				</div>
			</div>
		</div>
	</template>
}
